import React from "react";

import InlineSpinner from "../elements/InlineSpinner";
import { _t } from "../../../languageHandler";

/** The common body of components that show the progress of sending room invites. */
const InviteProgressBody: React.FC = () => {
    return (
        <div className="mx_InviteProgressBody">
            <InlineSpinner w={32} h={32} />
            <h1>{_t("invite.progress.preparing")}</h1>
            {_t("invite.progress.dont_close")}
        </div>
    );
};

export default InviteProgressBody;
